var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EBA809",
    fillRule: "evenodd",
    d: "M11.992 17.786v-1.228h-.442v1.21q.22.018.442.018m-1.77-.279v-.95H8.435a5.8 5.8 0 0 0 1.785.95m-2.763-1.922v-.547h.506s1.462-.01 1.463-.895v-4.5c.013-.238-.235-.557-.48-.603a3 3 0 0 0-.65-.08h-.84v-.545A5.76 5.76 0 0 0 6.215 12c0 1.354.465 2.6 1.245 3.585m.98-8.145h1.846v-.968a5.8 5.8 0 0 0-1.847.968m3.132-1.21v1.21H12V6.214q-.216 0-.429.016M17.785 12a5.79 5.79 0 0 1-4.464 5.634v-1.076h.516c1.881 0 3.241-1.97 2.838-3.708c-.162-.696-.819-1.135-1.482-1.29c1.108-.586 1.23-2.39.329-3.202c-.415-.435-.931-.673-1.296-.797c-.302-.102-.622-.121-.94-.121V6.353c2.614.576 4.5 2.88 4.5 5.647m1.072 0A6.857 6.857 0 1 1 12 5.143c3.857 0 6.857 3.07 6.857 6.857m-6.866 3.04c-.149.003-.256.005-.42.016v-2.554c.162.002.242.002.407 0l.203-.005c.638-.012 1.281-.025 1.84.308c.58.322.673 1.43.1 1.805c-.572.398-1.287.413-1.972.427l-.066.001zm-.42-3.769h.14c.644.005 1.32.01 1.872-.355c.535-.348.503-1.238-.051-1.547c-.512-.307-1.113-.301-1.693-.296h-.001a6 6 0 0 1-.267 0z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtg);
export default __webpack_public_path__ + "static/media/btg.4d73e0ad6597d3e6e0ff5b8b6cec3134.svg";
export { ForwardRef as ReactComponent };